import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Row, Col, Input } from 'antd'
import { useTranslation } from 'react-i18next'
import ChartComposition from './ChartComposition'
import ChartSociety from './ChartSociety'
import { openErrorPopup } from '../../../../components/ConfirmationPopups'
import * as _ from 'lodash'

interface Props {
  field: any
  form: any
}

const chartInitialTemplate = {
  societies: ['SeDomicilier'],
  structure: { elements: [], hierarchy: {} },
  values: {},
}

const ComparativeChart = (props: Props): JSX.Element => {
  const { t } = useTranslation()
  const { field, form } = props
  const [chart, setChart] = useState(
    field.value?.content || chartInitialTemplate
  )

  useEffect(() => {
    form.setFieldValue(field.name, { ...field.value, content: chart })
  }, [chart])

  const showEmptySocietyError = () => {
    openErrorPopup(
      t('ficheComparative.errorTitle'),
      t('ficheComparative.errorMessages.noEmptySociety')
    )
  }

  const societyBlankValues = () => {
    const newSocietyValues: any = {}
    const chartHierarchy = _.cloneDeep(chart.structure.hierarchy)
    Object.keys(chartHierarchy).forEach(mainElement => {
      const mainElementHierarchy: Array<string> = chartHierarchy[mainElement]
      newSocietyValues[mainElement] = {}
      mainElementHierarchy.forEach(subElement => {
        newSocietyValues[mainElement][subElement] = { type: 'none' }
      })
    })
    return newSocietyValues
  }

  const addConcurrent = () => {
    // prevent duplicate empty concurrents
    if (chart.societies.indexOf('') != -1) {
      showEmptySocietyError()
      return
    }
    const newSocieties = _.cloneDeep(chart.societies)
    newSocieties.push('')
    const newValues = _.cloneDeep(chart.values)
    newValues[''] = societyBlankValues()
    setChart({ ...chart, societies: newSocieties, values: newValues })
  }

  return (
    <Wrapper>
      <h2>{t('ficheComparative.comparativeChart.title')}</h2>
      <Row gutter={[0, 12]}>
        <Col span={24}>
          <Row gutter={[0, 2]}>
            <Col span={24}>
              <label>
                {t('ficheComparative.comparativeChart.sectionTitle')}
              </label>
            </Col>
            <Col span={24}>
              <Input
                placeholder="Titre"
                defaultValue={field.value?.title}
                onBlur={e =>
                  form.setFieldValue(field.name, {
                    ...field.value,
                    title: e.target.value,
                  })
                }
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[0, 2]}>
            <Col span={24}>
              <label>
                {t('ficheComparative.comparativeChart.sectionSubTitle')}
              </label>
            </Col>
            <Col span={24}>
              <Input
                placeholder="Sous titre"
                defaultValue={field.value?.subtitle}
                onBlur={e =>
                  form.setFieldValue(field.name, {
                    ...field.value,
                    subtitle: e.target.value,
                  })
                }
              />
            </Col>
          </Row>
        </Col>
      </Row>

      <h3>{t('ficheComparative.comparativeChart.compositionTitle')}</h3>
      <ChartComposition structure={chart.structure} setChart={setChart} />
      {chart.societies.map((element: string) => {
        const index = chart.societies.indexOf(element)
        return (
          <ChartSociety
            society={element}
            chart={chart}
            setChart={setChart}
            key={`${element}.${index}`}
          />
        )
      })}
      <Row>
        <Col span={2}>
          <button
            type="button"
            onClick={() => {
              addConcurrent()
            }}
          >
            {t('ficheComparative.comparativeChart.addConcurrent')}
          </button>
        </Col>
      </Row>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
`

export default ComparativeChart
